let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hVgAv")).then(() => parcelRequire('cr9Z3'));